import React from "react";
import Navbar from "../components/Home/Navbar";
import Products from "../components/Products/Products";

function ProductsPage() {
  return (
    <>
      <Navbar />
      <Products />
    </>
  );
}

export default ProductsPage;
